<template>
  <v-app id="receive-check">
    <div class="wrap-receive-check">
      <div class="check-top-header">
        <h2 class="headline">Receive Check Payment</h2>        
        <v-icon>credit_card</v-icon>  
      </div>

      <v-card>
        <v-layout class="py-4 px-6 mt-6">
          <h3>Payment Details</h3>
        </v-layout>
        <v-divider></v-divider>
        <v-container class="py-4 px-6 grid-list-md container--fluid">
          <v-form>
            <v-layout class="wrap xs12">
              <v-flex class="xs12 sm4 md3">
                <v-autocomplete
                  :items="clients"
                  item-text="full_name"
                  item-value="id"
                  v-model="preparedData.client_id"
                  label="Client Name"
                  placeholder="Please Enter"
                  :error-messages="errors($v.preparedData.client_id) || server_errors.client_id"
                  @focus="resetServerValidation"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex class="sm8 md9 hide-xs"></v-flex>
              <v-flex class="xs12 sm4 md3">
                <v-text-field
                  v-model="inputFieldDate"
                  :error-messages="errors($v.inputFieldDate) || server_errors.check_date"
                  label="Payment Date"                                    
                  placeholder="Please Enter"
                  hint="Enter date in MM-DD-YYYY format or click on icon and select"
                  persistent-hint
                  @focus="resetServerValidation"
                >
                  <template slot="prepend">
                    <v-menu
                      ref="menu1"
                      :label="`Payment Date*`"
                      :close-on-content-click="false"
                      v-model="menu1"
                      :nudge-right="40"
                      placeholder="Please Select"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">event</v-icon>
                      </template>
                      <v-date-picker 
                          v-model="datePickerDate" 
                          no-title
                          @input="menu1 = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex class="xs12 sm4 md3">
                <v-text-field
                  label="Reference Number"
                  placeholder="Please Enter"
                  v-model="preparedData.check_reference_number"
                  :error-messages="errors($v.preparedData.check_reference_number) || server_errors.check_reference_number"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-layout class="xs12 md6 mx-0">
                <v-spacer></v-spacer>
                <v-flex style="max-width: 180px; position: relative;">
                  <div style="position: absolute; left: 28px; top: -5px;"><strong>Amount Received</strong></div>
                  <v-text-field
                    outlined
                    single-line
                    label=""
                    v-model="preparedData.check_amount"
                    placeholder="0.00"
                    prepend-icon="attach_money"
                    class="check-input-text check-input-amount"
                    @keypress="onlyNumbers"
                    @keyup="updateInvoicePayments"
                    :error-messages="errors($v.preparedData.check_amount) || server_errors.check_amount"
                    @focus="resetServerValidation"
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>

      <v-card>
          <v-data-table
                  v-model="preparedData.invoices"
                  :headers="headers"
                  :items="invoices"
                  disable-pagination
                  hide-default-footer
                  :loading="loadingInvoices"
                  loader-height="2"
                  show-select
                  item-key="id"
                  class="mt-6"
                  @toggle-select-all="toggleSelectAll"
                  @item-selected="itemSelected"
                  mobile-breakpoint="100"
          >
            <template v-slot:item="{item, isSelected, select}">
                <tr :key="`tr-${item.id}`">
                    <td style="max-width: 52px;">
                      <v-simple-checkbox
                        :value="isSelected"
                        :ripple="false"
                        color="primary"
                        @input="select($event)">
                      ></v-simple-checkbox>
                    </td>
                    <td>
                      <router-link 
                        :to="'/invoice/' + item.id" 
                        class="remove-underline"
                      >
                      {{ item.invoice_number }}
                      </router-link>
                    </td>
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.remaining }}</td>
                    <td>
                      <v-text-field
                        outlined
                        single-line
                        v-model="item.payment"
                        @keypress="onlyNumbers"
                        @input="atPaymentInput(item)"
                        label=""
                        placeholder="0.00"
                        prepend-icon="attach_money"
                        class="check-input-text check-input-amount"
                        :rules="[currency]"
                        validate-on-blur
                        >
                      </v-text-field>
                    </td>
                </tr>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-flex class="xs12 px-6">
            <v-alert class="pa-2 mt-4 xs12" :value="$v.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">Please fill out form correctly</span>    
            </v-alert>
            <v-alert class="pa-2 mt-4 xs12" :value="!$v.$error && !sumValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">Make sure that a sum of all selected invoices is less or equal to check amount received.</span>    
            </v-alert>
            <v-alert class="pa-2 mt-4 xs12" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">{{ serverValidationMessage }}</span>    
            </v-alert>
          </v-flex>
          <v-card-actions class="py-4 px-6">
              <v-spacer></v-spacer>
              <v-btn class="dialog-btn" text @click.native="$router.go(-1)">Cancel</v-btn>
              <v-btn 
                class="dialog-btn" 
                @click.native="createPayment"
                :loading="loadingSave"
                :disabled="loadingSave"
              >Save</v-btn>
          </v-card-actions>
      </v-card>

    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import { preciseAdd, preciseMinus } from "@/common/preciseMath";
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, decimal, helpers } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages";

const validations = {
  preparedData: {
    client_id: { required },
    // check_date: { required },
    check_reference_number: { required },
    check_amount: {
      required,
      decimal,
      positive: v => !helpers.req(v) || v > 0,
      currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v) 
    },
  },
  inputFieldDate: { required, dateFormat: v => !helpers.req(v) || /^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/.test(v) }
}

export default {
  name: 'ReceiveCheckDataComponent',
  mixins: [validationMixin],
  validations,
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      menu1: false,  
      paymentDate: '',
      loading: false,
      loadingInvoices: false,
      loadingSave: false,
      sumValidationDirty: false,
      sumValidation: true,
      preselectedClient: false,
      headers: [
          {text: 'Description', align: 'left', value: 'id', sortable: false},
          {text: 'Due Date', value: 'status', sortable: false},
          {text: 'Original Amount', value: 'full_name', sortable: false},
          {text: 'Open Balance', value: 'assigned_to_name', sortable: false},
          {text: 'Payment', value: 'date', sortable: false}
      ],
      selected: [],
      invoices: [],
      clients: [],
      datePickerDate: null,
      inputFieldDate: moment().format('MM[-]DD[-]YYYY'),
      preparedData: {
        invoices: [],
        check_amount: null,
        check_reference_number: null,
        check_date: moment().format('YYYY[-]MM[-]DD'),
        client_id: null
      },
      required: v => !!v || 'This field is required',
      currency: v => (/^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0\.+([0-9]{1,2})?$/.test(v) || v === undefined || String(v) === '') || 'Enter valid currency format',
      dateFormat: v => (/^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/.test(v) || v === undefined || String(v) === '') || 'Must be in MM-DD-YYYY format',
      serverValidation: true,
      serverValidationMessage: 'Oops something went wrong...',
      server_errors: {}
    }
  },
  mounted() {
    if(this.stateData && this.stateData.client_id) {
      this.preparedData.client_id = Number(this.stateData.client_id)
      this.preselectedClient = true
      this.setTableData({key: 'receiveCheckPaymentTableData', value: null})
    }
    this.getClients()
  },
  methods: {
    ...mapActions(["setTableData", 'vEmit']),
    toggleSelectAll (e) {
      e.items.forEach(i => {
        i.payment = e.value ? i.remaining : "0.00"
      })
      this.$nextTick(() => {
        if(this.sumValidationDirty) { this.validateSum() }
      })
    },
    itemSelected (e) {
      e.item.payment = e.value ? e.item.remaining : "0.00"
      this.$nextTick(() => {
        if(this.sumValidationDirty) { this.validateSum() }
      })
    },
    atPaymentInput (e) {
      this.$nextTick(() => {
        if(this.sumValidationDirty) { this.validateSum() }
      })
    },
    getClients() {
      ApiService.get('/client/list', { statuses: ['active']})
        .then(response => {
          this.clients = response.data.clients;
        })
        .catch(erorr => {
          console.log(error);
        })
    },
    getUnpayedInvoices(id) {
      let body = { client_id: id }
      this.loadingInvoices = true
      ApiService.get('/payment/un_payed_invoices', body)
        .then(response => {
          this.loadingInvoices = false
          this.resetForm()
          this.invoices = response.data.invoices;
          if(this.invoices.length > 0){
            this.invoices.forEach(i => {
              i.remaining = parseFloat(i.remaining).toFixed(2)
              i.total = parseFloat(i.total).toFixed(2)
              i.payment = "0.00"
            })
          }
        })
        .catch(erorr => {
          this.loadingInvoices = false
          console.log(error);
        })
    },
    createPayment() {
      this.resetServerValidation()
      this.formatPreparedData()
      this.$v.preparedData.$touch()
      this.$v.inputFieldDate.$touch()
      this.validateSum()
      if(!this.$v.$invalid && this.sumValidation){
        let body = Object.assign({}, this.preparedData)
        body.invoices = body.invoices.map(i => { return { id: i.id, payment: i.payment }})

        this.loadingSave = true 
        // console.log('Test completed');
        // return
        ApiService.put('/payment/create', body)
          .then(response => {
            this.loadingSave = false
            this.vEmit({ 
              name: "notification", 
              data: {
                status: 'success',
                text: 'Check payment has been successfully added.'
              }
            });
            this.resetForm()
            if(this.preselectedClient) { 
              this.$router.go(-1) 
            } else {
              this.getUnpayedInvoices(this.preparedData.client_id)
            }
          })
          .catch(({ response }) => {
            this.loadingSave = false
            this.serverValidation = false
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(response.data.error)
            }
            if(response.data.message){
              this.serverValidationMessage = response.data.message
            }
            if (response.data.errors) {
              if (typeof response.data.errors === 'string') {
                  this.serverValidationMessage = response.data.errors
              } else {
                  this.server_errors = response.data.errors
              }
            }
          })
      }
    },
    formatPreparedData() {
      let invoices = []
      this.invoices.forEach(i => {
        if (this.preparedData.invoices.some(j => j.id === i.id)) {
          invoices.push(i)
        }
      })
      this.preparedData.invoices = _.cloneDeep(invoices)
    },  
    updateInvoicePayments() {
      let inputAmount = Number(this.preparedData.check_amount)
      if(isNaN(inputAmount)) { return }
      let invoices = []
      this.invoices.forEach(i => {
        if(inputAmount > 0) {
          if(i.remaining <= inputAmount) {
            i.payment = parseFloat(i.remaining).toFixed(2)
            invoices.push(i)
            inputAmount = preciseMinus(inputAmount, Number(i.payment))
          } else {
            i.payment = parseFloat(inputAmount).toFixed(2)
            invoices.push(i)
            inputAmount = 0
          }
        } else {
          i.payment = parseFloat(inputAmount).toFixed(2)
        }
      })
      this.preparedData.invoices = _.cloneDeep(invoices)
      this.$nextTick(() => {
        if(this.sumValidationDirty) { this.validateSum() }
      })
    },
    validateSum() {
      let sum = 0
      let invoices = []
      this.invoices.forEach(i => {
        if (this.preparedData.invoices.some(j => j.id === i.id)) {
          invoices.push(i)
        }
      })
      sum = invoices.map(i => {
        return isNaN(Number(i.payment)) ? 0 : Number(i.payment)
      }).reduce((k, p) => {return preciseAdd(k, p)}, 0)
      if(
        !this.no_data.includes(this.invoices) &&
        Array.isArray(this.invoices) &&
        !this.no_data.includes(this.preparedData) &&
        !this.no_data.includes(this.preparedData.invoices) &&
        Array.isArray(this.preparedData.invoices) &&
        invoices.every(i => !isNaN(Number(i.payment))) &&
        !this.no_data.includes(this.preparedData.check_amount) &&
        !isNaN(Number(this.preparedData.check_amount)) &&
        sum <= Number(this.preparedData.check_amount)
      ){ this.sumValidation = true } else { this.sumValidation = false }
      this.sumValidationDirty = true
    },
    resetSumValidation () {
      this.sumValidationDirty = false
      this.sumValidation = true
    },
    resetForm () {
      this.invoices = []
      this.preparedData.invoices = []
      this.preparedData.check_amount = null
      this.preparedData.check_reference_number = null
      // this.preparedData.check_date = moment().format('YYYY[-]MM[-]DD')
      this.$v.$reset()
      this.resetSumValidation()
    },
    onlyNumbers($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }
    },
    goToPayments(){
      this.$router.push('/payments')
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '));
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
      this.server_errors = {}
    },
    errors: getValMessage(valMessages)(validations)
  },
  computed: {
    ...mapGetters({
      stateData: 'receiveCheckPaymentTableData'
    }),
    computedDate(value) {
      return this.preparedData.check_date ? moment(this.preparedData.check_date).format('MM[-]DD[-]YYYY') : ''
    }
  },
  watch: {
    'preparedData.client_id': function(val) {
      if(val) {
        this.resetForm()
        this.getUnpayedInvoices(val)
      }
    },
    datePickerDate(val) {
      this.preparedData.check_date = val
    },
    inputFieldDate(val) {
      if(/^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/.test(val)) {
        this.preparedData.check_date = moment(val, 'MM[-]DD[-]YYYY').format('YYYY[-]MM[-]DD')
      } else if (val === undefined || String(val) === '') {
        this.preparedData.check_date = val
      }
    },
    computedDate(val) {
      if(val !== this.inputFieldDate) {
        this.inputFieldDate = val
      }
      if(moment(val, 'MM[-]DD[-]YYYY').format('YYYY[-]MM[-]DD') !== this.datePickerDate) {
        if(/^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/.test(val)) {
          this.datePickerDate = moment(val, 'MM[-]DD[-]YYYY').format('YYYY[-]MM[-]DD')
        } else if (val === undefined || String(val) === '') {
          this.datePickerDate = val
        }
      }
    }
  }
}
</script>

<style>

  /*Input text fields*/
   .check-input-text .v-input__slot{
    min-height: 25px !important;
    border-radius: 3px !important;
    border: 0px solid!important;
    /* border: 1px solid!important; */
    margin: 17px 0px 0px 0px;

  }
  .check-input-text:not(.primary--text):not(.error--text) .v-input__slot{
    border: 0px solid lightgray!important;
  }
  .check-input-text.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 5px 0px 0px;
  }
  .check-input-text .v-input__slot .v-text-field__slot input{
    margin: 0px;
    font-size: 13px;
  }

   .check-input-text .v-input__prepend-outer{
     margin-top: 22px !important;
     margin-right: 0px;
   }

  .check-input-text .v-icon{
    font-size: 20px;
  }
  .check-input-amount .v-input__slot{
    max-width: 150px;
    min-width: 75px;
  }
  .inv-input-desc .v-input__slot{
    max-width: 600px;
    min-width: 250px;
  }

</style>